// extracted by mini-css-extract-plugin
export default {"Botao":"estilo_Botao__2lI-k","Alinha":"estilo_Alinha__K6xKQ"};